import React from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";

interface ItemDetailedViewHeaderProps {
  headerText: string | undefined;
  loading: boolean;
  isReloadingInBackground: boolean;
}

export default function ItemDetailedViewHeader(
  { headerText, loading, isReloadingInBackground }: ItemDetailedViewHeaderProps) {
  const navigate = useNavigate();
  return (
    <header className="d-flex justify-content-between">
      <h1 className="fw-semibold mb-0">
        <button onClick={() => navigate(-1)} className="bg-transparent border-0">
          <i className="bi bi-arrow-left" />
        </button>
        {headerText}
      </h1>
      {loading && isReloadingInBackground && <Loading isInline={true} />}
    </header>
  );
}
